import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { globals } from 'src/app/globals';
import { CRMUC } from 'src/app/models/crm/crmuc';

@Injectable({
  providedIn: 'root'
})
export class CrmucService {

  constructor(private http: HttpClient) { }

  consultarUCs() {
    return this.http.get<CRMUC[]>(globals.apiUrl + '/api/CRMUC/Lista');
  }

  consultarUCsPorOportunidade(idOportunidade) {
    return this.http.get<CRMUC[]>(globals.apiUrl + '/api/CRMUC/ListarPorOportunidade',
      { params: new HttpParams().set('idOportunidade', idOportunidade) });
  }

  consultarUCsComPaginacao(idOportunidade, numero: string, paginaAtual, qtdRegistros, campoOrdenacao, orientacaoOrdenacao) {

    let parametros = new HttpParams()
      .set('idOportunidade', idOportunidade)
      .set('pag', paginaAtual)
      .set('qt', qtdRegistros)
      .set('ordem', campoOrdenacao)
      .set('asc_desc', orientacaoOrdenacao);

    if (numero.trim() !== '') {
      parametros = parametros.set('numero', numero);
    }

    return this.http.get<any>(globals.apiUrl + '/api/CRMUC/ListaPag',
      {
        params: parametros
      });
  }

  consultarPorIdUC(idUC) {
    return this.http.get<any>(globals.apiUrl + '/api/CRMUC/Buscar',
      { params: new HttpParams().set('id', idUC) });
  }

  salvar(uc: CRMUC) {
    return this.http.post(globals.apiUrl + '/api/CRMUC/Salvar', uc);
  }

  excluir(id) {
    return this.http.delete(globals.apiUrl + '/api/CRMUC/Excluir',
      { params: new HttpParams().set('id', id) });
  }
}
